import { render, staticRenderFns } from "./FeatureImage.vue?vue&type=template&id=2718842a&scoped=true&"
import script from "./FeatureImage.vue?vue&type=script&lang=js&"
export * from "./FeatureImage.vue?vue&type=script&lang=js&"
import style0 from "./FeatureImage.vue?vue&type=style&index=0&id=2718842a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718842a",
  null
  
)

export default component.exports